<template>
  <v-container
    id="product-group"
    fluid
    tag="section"
  >
    <filter-form 
      :filter-form="filterForm" 
      :schoolLevels="schoolLevels" 
      :types="types"
    />
    <product-group-table 
      :product-groups="productGroups" 
      :schoolLevels="schoolLevels" 
      :types="types"
      :filterForm="filterForm"
    />
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem, limit)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import ProductGroupTable from './components/ProductGroupTable'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { productStatusOptions } from '../../../helpers/constants'
  const ProductGroupRepository = RepositoryFactory.get('product_group')
  const SchoolLevelRepository = RepositoryFactory.get('school_level')
  const TypeRepository = RepositoryFactory.get('type')
  export default {
    components: { FilterForm, ProductGroupTable },
    data () {
      return {
        filterForm: {
          keyword: '',
          schoolLevelIds: [],
          typeIds: []
        },
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        productGroups: [],
        loading: true,
        schoolLevels: [],
        types: [],
        watchModule: ''
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getProductGroupList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getProductGroupList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      await Promise.all([this.getListSchoolLevel(),
        this.getListType()])
      this.getProductGroupList()

      Bus.$on('product-group-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getProductGroupList()
      })

      Bus.$on('product-group-reload', () => {
        this.getProductGroupList()
      })

      this.watchModule = this.$store.watch(
        (state) => {
          return state.module
        },
        (newVal) => {
          this.filterForm = {
            keyword: '',
            schoolLevelIds: [],
            typeIds: []
          }
          Bus.$emit('product-group-list-filter', this.filterForm)
        },
        {
          deep: true
        }
      )
    },
    beforeDestroy () {
      Bus.$off('product-group-reload')
      Bus.$off('product-group-list-filter')
      this.watchModule()
    },
    methods: {
      async getProductGroupList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          status: this.filterForm.status,
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId,
          schoolLevelIds: this.filterForm.schoolLevelIds,
          typeIds: this.filterForm.typeIds,
        }
        // const loader = this.$loading.show()
        this.appLoadingData(true)
        const response = await ProductGroupRepository.list(params)
        // loader.hide()
        this.appLoadingData(false)
        this.loading = false
        if (response.success) {
          this.productGroups = _.get(response, 'data', []).map((group,index) => ({
            ...group,
            index: index + 1,
            statusText: _.get(productStatusOptions.find(s => s.value === group.status), 'text', ''),
            urls: _.get(group, 'urls', []).map((url, index) => ({
              id: `${index}_${(new Date()).getTime()}`,
              inputUrl: url.url,
            })),
          }))
          this.totalItem = response.totalItem
        }
      },
      async getListSchoolLevel() {
        if(this.$store.state.listSchoolLevelDrawer) {
          this.schoolLevels  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
            return
        }
        
        const res = await SchoolLevelRepository.listTypeSchoolLevel()
        if (res.success) {
          this.schoolLevels = _.get(res, 'data', [])
        } else {
          this.schoolLevels = []
        }
      },
      async getListType() {
        const res = await TypeRepository.list({limit: 1000})

        if (res.success) {
          this.types = _.get(res, 'data', [])
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
          this.types = []
        }
      }
    },
  }
</script>
